.root {
  background: var(--episode-card-background);
  border: 1px solid var(--episode-card-border-color);

  svg {
    transform-origin: 50% 50%;
    transition: all 0.25s;
  }

  &:hover {
    color: var(--primary);

    svg {
      scale: 1.1;
    }
  }
}
